import React from 'react'
import injectStyles from 'react-jss'

const styles = injectStyles({
  note: {
    fontSize: 11,
    opacity: 0.8,
  },
})

const Note = ({ hidden = false, children }) => {
  if (hidden) return null
  return <div style={styles.note}>{children}</div>
}

export default Note



// WEBPACK FOOTER //
// ./src/Components/Note/index.js